import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import qs from 'qs';

import { withBuyers, withSellers } from 'containers/ContactsList';
import { currentUserRoleSelector } from 'redux/auth/selectors';
import ContactCard from '../Sources/components/ContactCard';

class ContactContainer extends Component {
  static propTypes = {
    currentUserRole: PropTypes.string.isRequired,
    history: PropTypes.shape({
      location: PropTypes.shape({
        search: PropTypes.string,
        pathname: PropTypes.string,
      }).isRequired,
      push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,    
  };

  constructor(props) {
    super(props);
    const isVendor = props.history.location.pathname === '/vendors';
    const hoc = isVendor ? withSellers : withBuyers;
    this.state = {
      WrappedContactCard: hoc(ContactCard),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.history.location.pathname !== this.props.location.pathname) {
      const isVendor = nextProps.history.location.pathname === '/vendors';
      const hoc = isVendor ? withSellers : withBuyers;
      const WrappedContactCard = hoc(ContactCard);
      this.setState({ WrappedContactCard });
    }
  }

  render() {
    const { currentUserRole, history } = this.props;
    const { WrappedContactCard } = this.state;
    const isVendor = history.location.pathname === '/vendors';
    const isRest = currentUserRole === 'Buyer';
    const { suid } = qs.parse(history.location.search.substring(1));
    return (
      <div className="customer-page">
        <WrappedContactCard
          helper="broadcast/invoices"
          isRest={isRest}
          isVendor={isVendor}
          location={history.location}
          onCreateContactSuccess={() => history.push('/retail-customers')}
          push={history.push}
          title={'RetailCustomers'}
          setExpanded={expanded => history.push(
            expanded === -1 ? '/retail-customers' : `/retail-customers?suid=${expanded}`,
          )}
          suid={suid}
          isRetailPage={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUserRole: currentUserRoleSelector(state),
});

export default connect(mapStateToProps)(ContactContainer);
